import { Response } from './../models/response.model';
import { AuthBaseService } from './auth/auth-base.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TipoLider } from '../models/tipo-lider.model';
import { BaseService } from './base/base.service';

@Injectable({
  providedIn: 'root'
})
export class TipoLiderService  extends BaseService  {

  private modelName = 'tipo-lider';
  constructor(
    protected http: HttpClient,
    private authBaseService:AuthBaseService,
    private baseService: BaseService
  ) {
    super(http);

  }

  get urlApi() {
    return environment.apiEndpoint + this.modelName;
  }

  getTipoLider(): Observable<Response<TipoLider[]>> {
    return this.http.get<Response<TipoLider[]>>(`${environment.apiEndpoint}/${this.modelName}`);
  }



}
